import { createAction, props } from '@ngrx/store';

export const setSelectedOpportunityId = createAction(
  '[Cart] Set Selected Opportunity Id',
  props<{ opportunityId: number | undefined }>(),
);
